import config from '@/config';
import axios from 'axios';

export default {
    getSearchResults(query: String, type: String|null, similarity: Number|null, distance: Number|null, limit: Number|null, page: Number|null) {
        let url = `${config.appBaseUrl}/api/master-search?query=${query}`;

        if (type) {
            url += `&type=${type}`;
        }

        if (similarity) {
            url += `&similarity=${similarity}`;
        }

        if (distance) {
            url += `&distance=${distance}`;
        }

        if (limit) {
            url += `&limit=${limit}`;
        }

        if (page) {
            url += `&page=${page}`;
        }

        return axios.get(url);
    },

    getSearchAutocompleteResults(query: String) {
        let url = `${config.appBaseUrl}/api/search/autocomplete?query=${query}`;

        return axios.get(url);
    },
};